import { Component, OnInit, Input } from '@angular/core';
import { SetService, HttpService, PageService, JwtService } from 'ngx-block-core';
import { selectTitleSize } from "../../../data/data";
import { BlockBaseComponent } from "../../../components/block";
import { selectTextColor } from "../../../data/data";
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-sucu06-element0010001',
    templateUrl: './sucu06-element0010001.component.html',
})
export class Sucu06Element0010001Component extends BlockBaseComponent implements OnInit {
    doValueChange() {
        throw new Error("Method not implemented.");
    }
    value

    @Input() sets = {
        blockCode: "sucublock31",
        blockId: "",
        layoutId: "",
        blockType: 'element',
        blockChildType: '',
        blockName: "元素积木1",
        versionCode: 7,
        events: [
            {
                label: "重置",
                value: "reset",
                data: { setParams: ["刷新 : true|false", '只刷新 : true|false', '备用'] }
            },
        ],
        styles: {
            nzDefaultTitle: "",
            nzTitle: "标题",
            nzTitleSize: "h1",
            nzTextColor: "",
            nzTimer: {
                nzUsed: false,
                nzTime: 1,
            },
            nzMode: "text"//text tag

        },
        datas: {
            nzDynamicValue: {
                nzUsed: false,
                nzDynamicSql: ""

            },
            nzLinkage: {
                nzUsed: false,

                nzEvents: [
                    // {
                    //   blockid:blockid,
                    //   type:"value"//value,datasource
                    // }
                ],//blockid
            },
            nzLinkageData: {
                nzLinkageType: "default",//group
                nzDynamicSql: "",
                nzGroupLinkageRule: "",
                nzGroupRules: {
                    linkage1: "",
                    linkage2: "",
                    linkage3: "",
                    linkage4: ""
                }
            },



        }
    };


    constructor(
        public setService: SetService,
        protected pageService: PageService,
        protected jwtService: JwtService,
        protected http: HttpService,
        private activatedRoute: ActivatedRoute
    ) {
        super(setService, pageService, jwtService, http);
    }
    ngOnInit() {

        super.ngOnInit()
        console.log("Sucu06Element0010001Component", "ngOnInit")
        if (this.sets['styles']['nzTimer']['nzUsed']) {
            this.nzTimer = setInterval(() => {
                this.getControl();
            }, this.sets['styles']['nzTimer']['nzTime'] * 1000)
        } else {
            this.getControl();
        }


    }
    autoUpdate() {

        //v3,升级自定义表单参数
        if (this.sets.versionCode < 2) {

            this.sets.blockCode = "sucublock31";

            this.sets.versionCode = 2;
        }
        //v3,升级自定义表单参数
        if (this.sets.versionCode < 4) {

            this.sets.styles['nzTimer'] = {
                nzUsed: false,
                nzTime: 1,
            }

            this.sets.versionCode = 4;
        }
        if (this.sets.versionCode < 5) {
            this.sets.styles['nzDefaultTitle'] = "";
            if (typeof this.sets.datas.nzLinkage == "undefined") {
                this.sets.datas['nzLinkage'] = {
                    nzUsed: false,
                    nzEvents: [

                    ],
                };
                this.sets.datas['nzLinkageData'] = {
                    nzLinkageType: "default",//group
                    nzDynamicSql: "",
                    nzGroupLinkageRule: "",
                    nzGroupRules: {
                        linkage1: "",
                        linkage2: "",
                        linkage3: "",
                        linkage4: ""
                    }
                }
            }
            this.sets.versionCode = 5;
        }

        if (this.sets.versionCode < 6) {
            this.sets.styles['nzMode'] = "text";

            this.sets.versionCode = 6;
        }
        if (this.sets.versionCode < 7) {
            this.sets['events'] = [
                {
                    label: "重置",
                    value: "reset",
                    data: { setParams: ["刷新 : true|false", '只刷新 : true|false', '备用'] }
                },
            ]
            this.sets.versionCode = 7;
        }




    }

    setDataInit() {
        this.setData = [
            {
                tabName: '数据',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            {
                                name: 'nzDefault',
                                outputs: {
                                    ngModelChange: (event) => {
                                        this.setService.setDatas[this.blockid][0]['datas'][0]['data'][1]['show'] = event;
                                    }
                                }
                            },
                            {
                                name: 'button',
                                show: this.sets.datas.nzDynamicValue.nzUsed,
                                inputs: { nzText: ['刷新'], nzLayout: [0, 24], nzAligns: ['center'] },
                                outputs: {
                                    onClick1: () => {
                                        this.setService.onReLoadbBlock(this.layoutid)

                                    }
                                }
                            },
                        ]
                    }


                ]
            },
            {
                tabName: '样式',
                datas: [

                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], nzData: [{ value: 'text', label: '标题' }, { value: 'tag', label: '标签' }] }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "前置标题 : ", nzKeys: ['styles', 'nzDefaultTitle'] }
                            },

                            {
                                name: 'select',
                                inputs: { nzText: "标题大小 : ", nzKeys: ['styles', 'nzTitleSize'], nzData: selectTitleSize }
                            },
                            {
                                name: 'select',
                                inputs: { nzText: "主题:", nzKeys: ['styles', 'nzTextColor'], nzData: selectTextColor }
                            },
                            {
                                name: 'color',
                                inputs: { nzText: "颜色 : ", nzKeys: ['styles', 'nzTextColor'] }
                            },
                            {
                                name: 'nzTimer'
                            },

                        ]
                    },

                ]
            },

        ]
    }
    baseInit() {

        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                console.log("sets", this.sets, this.blockid)

                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;


                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }

                this.pzListening();
            }
            else {//静态
                if (typeof this.sets == "string")
                    this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
            }
            this.Listening();
        }
    }
    //定时器
    private nzTimer;
    getControl() {

        if (this.sets.datas.nzDynamicValue.nzUsed) {
            this.linkageValue("", 4);
        }

    }
    linkValue = {
        linkage: "",
        linkage2: "",
        linkage3: "",
        linkage4: ""
    }
    getUrlValue(sql) {
        const value = this.pageService.getRouteParams(this.activatedRoute, sql.replace(new RegExp("@url@", "gm"), ''));
        this.sets.styles.nzTitle = value;
    }
    linkageValue(value, type) {

        this.linkValue['linkage' + type] = value;
        let sql = this.sets.datas.nzDynamicValue.nzDynamicSql;
        console.log("元素原始sql:", sql, sql.indexOf("@url@"));
        if (sql.indexOf("@url@") === 0) {
            this.getUrlValue(sql);
            return;
        }

        if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
        if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
        if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);

        let body = {
            // "dynamicSql": 'select test001_name as value from t_test001 where test001_id=16',
            "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.layoutid),
            "pageSize": 0,
            "nowPage": 0,
            "paramMap": [],
            "tableSort": [],
            "searchMap": {
            }
        }
        // console.log("body:" + JSON.stringify(body));
        if (sql.indexOf("@linkage") == -1 && body.dynamicSql != "") {
            console.log("执行sql:", body.dynamicSql);

            this.http.postHttp("/system/dynamicSql", body).subscribe(
                (data: any) => {
                    // console.log("dynamicSql:" + JSON.stringify(data));
                    if (data.data.list.length > 0) {
                        this.sets.styles.nzTitle = data.data.list[0]['VALUE'];
                    }

                })
        } else {
            console.log("未执行sql:", body.dynamicSql);

        }

    }

    ngOnDestroy() {
        super.ngOnDestroy();
        console.log("ngOnDestroy注销");
        if (this.nzTimer) {
            clearInterval(this.nzTimer);
        }
    }
    pzSwitchFn(data) {
        console.log('pzListening2', data)
        switch (data['type']) {
            case 'nzTimertrue':
                if (!this.nzTimer) {
                    this.nzTimer = setInterval(() => {
                        this.getControl();
                    }, this.sets['styles']['nzTimer']['nzTime'] * 1000)
                }
                break;
            case 'nzTimerfalse':
                if (this.nzTimer) {
                    clearInterval(this.nzTimer);
                    this.nzTimer = null;
                }
                // this.setService.onReLoadbBlock(this.layoutid)
                break;
            default:
                break;
        }
    }
    switchFn(data) {
        console.log("Listening-input2", this.blockid, data)

        let array0 = [];
        let array1 = [];
        switch (data['type']) {

            case 'linkagevalue':
                this.linkageValue(data.datas.value, '')

                break;
            case 'linkagevalue2':
                this.linkageValue(data.datas.value, '2')
                break;
            case 'linkagevalue3':
                this.linkageValue(data.datas.value, '3')
                break;
            case 'linkagesetValue':
                this.sets.styles.nzTitle = data.datas.value;
                break;

            case 'reset':
                if (data.datas.param1 == "true") {
                    this.linkageValue("value", 4);
                } else {
                    this.sets.styles.nzTitle = "";
                    if (data.datas.param0 == "true") {
                        this.linkageValue("value", 4);
                    }
                }

                break;


            default:
                break;
        }
    }







}
